import { Component } from '@angular/core';

@Component({
  selector: 'app-patient-transactions',
  templateUrl: './patient-transactions.component.html',
  styleUrls: ['./patient-transactions.component.less'],
})
export class PatientTransactionsComponent {
  constructor() {}
}
